import * as React from 'react';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { Dayjs } from 'dayjs';
import { useState } from 'react';
import { Box } from '@mui/material';

type FilterDateType = {
  label: string;
  handleDateValuesChange: (date: Dayjs | null) => void;
};

export const FilterDate = ({ label, handleDateValuesChange }: FilterDateType) => {
  const [selectDate, setSelectDate] = useState<Dayjs | null>(null);

  const handleDateChange = (date: Dayjs | null) => {
    setSelectDate(date);
    handleDateValuesChange(date);
  };

  return (
    <Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={['DatePicker']}>
          <DateTimePicker
            label={label}
            format="DD/MM/YYYY HH:mm"
            value={selectDate}
            onChange={handleDateChange}
            ampm={false}
          />
        </DemoContainer>
      </LocalizationProvider>
    </Box>
  );
};
